import React, { useContext, useState } from "react";
import { useDispatch } from "react-redux";
import toaster from "toasted-notes";
import Cookies from "js-cookie";

import "toasted-notes/src/styles.css";
import { ActionTypes, ChargeItemsContext } from "../../../context";
import { OrderTopSectopmWrap } from "../catalogue.styles";
import { updateSalesOrder } from "../../../../../../../redux/actions/salesOrder.acton";

const OrderHeaderSection = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { state, contextDispatch } = useContext(ChargeItemsContext);
    const dispatch = useDispatch();

    const handleUpdateOrder = async () => {
        setIsSubmitting(true);
        const groupCustomerId = Cookies.get("groupCustomerId");
        try {
            const payload = {
                id: state.orderId,
                ownerID: groupCustomerId,
                items: [],
            };

            const { status, message } = await dispatch(updateSalesOrder(payload));
            setIsSubmitting(false);

            if (status) {
                contextDispatch({
                    type: ActionTypes.CLEAR_ITEMS,
                });
            } else {
                toaster.notify(message || "Sorry, an error occurred, Kindly try again.", {
                    duration: 5000,
                    position: "bottom",
                });
            }
        } catch (error) {
            setIsSubmitting(false);
        }
    };
    return (
        <OrderTopSectopmWrap>
            <div>
                <h3>Order Details</h3>
                <p>Order No: {state.orderNumber} </p>
            </div>
            {state.itemsState?.length > 0 && (
                <>
                    {isSubmitting ? (
                        <p className="sales__order-clear-link-loading">clearing...</p>
                    ) : (
                        <p className="sales__order-clear-link" onClick={handleUpdateOrder}>
                            Clear
                        </p>
                    )}
                </>
            )}
        </OrderTopSectopmWrap>
    );
};

export default OrderHeaderSection;
